import { useHistory } from 'react-router-dom';
import Button from '../Button/Button';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Повернення на попередню сторінку.
 *
 * Раніше це був голий значок стрілки без доступної назви, до того ж прихований
 * на мобільному. Тепер це підписане посилання — тупикових екранів не лишається.
 */
export default function BackButton({ className = '' }) {
  const { goBack } = useHistory();
  const language = useLanguage();

  return (
    <Button variant='link' className={`back-link ${className}`} onClick={goBack}>
      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
        <path
          d='M15 5l-7 7 7 7'
          stroke='currentColor'
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
      {language === 'en' ? 'Back' : 'Назад'}
    </Button>
  );
}
